import React from 'react';
import { ProductApi } from 'common/types';
import ProductListItem from './ProductListItem';
import { List } from '@mui/material';
import { moveElementLeft, moveElementRight } from 'common/utils/arrays';

interface Props {
	products: ProductApi[];
	disabled?: boolean;
	onChange: (value: ProductApi[]) => void;
}
const ProductList = (props: Props) => {
	const { products, disabled, onChange } = props;

	const handleRemove = ({ id }: ProductApi) => {
		onChange(products.filter((p) => p.id !== id));
	};

	const handleReorder = ({ id }: ProductApi, direction: 'up' | 'down') => {
		const index = products.findIndex((p) => p.id === id);
		if (direction === 'up') {
			onChange(moveElementLeft(products, index));
		} else {
			onChange(moveElementRight(products, index));
		}
	};

	return (
		<List>
			{products.map((product) => (
				<ProductListItem
					key={product.id}
					product={product}
					onDelete={handleRemove}
					onReorder={handleReorder}
					disabled={disabled}
				/>
			))}
		</List>
	);
};

export default ProductList;
